import axios from 'axios';
import catchify from 'catchify';
import set from 'lodash/set';

import { getCSRFCookie } from '~/util/global';

const buildApiRequest = (
  axiosInstance = axios,
  url,
  method = 'get',
  data = {},
  headers = { 'Content-Type': 'application/json' },
) => (
  catchify(axiosInstance({
    data,
    url,
    method,
    withCredentials: true,
    headers: {
      'X-CSRFToken': getCSRFCookie(),
      ...headers,
    },
  }))
);

const initialState = () => ({
  error: '',
  isComplete: false,
  isLoading: false,
  isReady: false,
  paymentType: '',
  order: null,
});

export const mutations = {
  reset(state) {
    set(state, 'error', '');
    set(state, 'isComplete', false);
    set(state, 'isLoading', false);
    set(state, 'isReady', false);
    set(state, 'paymentType', '');
  },
  setError(state, value) {
    set(state, 'error', value);
  },
  setIsComplete(state, value) {
    set(state, 'isComplete', value);
  },
  setIsLoading(state, value) {
    set(state, 'isLoading', value);
  },
  setIsReady(state, value) {
    set(state, 'isReady', value);
  },
  setPaymentType(state, value) {
    set(state, 'paymentType', value);
  },
  setOrder(state, value) {
    set(state, 'order', value);
  },
};

export const getters = {
  error: (state) => state.error,
  isComplete: (state) => state.isComplete,
  isLoading: (state) => state.isLoading,
  isReady: (state) => state.isReady,
  paymentType: (state) => state.paymentType,
  order: (state) => state.order,
};

export const actions = {
  onChange({ commit }, event = {}) {
    const {
      value,
      complete,
      error,
    } = event;

    if (value.type) {
      commit('setPaymentType', value.type);
    }

    commit('setIsComplete', complete);
    commit('setError', error);
  },

  async createOrder({ commit, state, rootGetters }, uuid) {
    // validate stripe-elements flag
    const stripeElements = await this.$experiments.enroll('stripe-elements') === 'new-stripe';
    if (!stripeElements) return;

    // tax applies only for upgrade
    const isDowngrade = rootGetters['changePlan/isDowngrading'];
    if (isDowngrade) return;

    // getting new plan
    const newPlanSelectedId = rootGetters['changePlan/newPlanSelected']?.id;
    if (!newPlanSelectedId || !uuid) return;

    const data = {
      uuid,
      plan_id: newPlanSelectedId,
      stripe_order_id: state?.order?.stripe_order_id,
    };
    const [error, response] = await buildApiRequest(
      this.$axios,
      '/cart/stripe-elements/order/',
      'post',
      data,
    );

    if (error) {
      commit('setError', error);
    }

    commit('setOrder', response.data);
  },
};

export { initialState as state };
